export default {"src":"/_next/static/media/hamburger.92954879.svg","height":11,"width":25,"blurWidth":0,"blurHeight":0};